import { mapGetters } from 'vuex';
import {
  LANG_CODE_JAPANESE,
  LANG_CODE_VIETNAMESE,
  HINT_TEXT_MONTH_JAPANESE,
  HINT_TEXT_MONTH_VIETNAMESE,
  HINT_TEXT_DATE_JAPANESE,
  HINT_TEXT_DATE_VIETNAMESE,
  REGEX_DATE_JAPANESE,
  REGEX_DATE_VIETNAMESE,
  REGEX_MONTH_JAPANESE,
  REGEX_MONTH_VIETNAMESE,
  EVENT_BASIC_INFORMATION_FIELD,
  EVENT_ENTRY_INFORMATION_FIELD,
  PUBLIC_FLAG
} from '@/common/constants';
import { OTHER_SELECT } from '../common/constants';
import { Trans } from '@/plugins/translation.js';
import { getEventFromLS } from '@/common/index';
import moment_timezone from 'moment-timezone';
import moment from 'moment';

export const globalMixin = {
  data: () => ({
    MALE: 0,
    FEMALE: 1,

    DISPLAY: 1,
    UNDISPLAY: 0,

    READ: 1,
    UNREAD: 0,

    STATUS_CODE_SUCCESS: 0,
    STATUS_CODE_ERROR: -1,

    STEP_ONE: 1,
    STEP_TWO: 2,
    STEP_THREE: 3,
    STEP_FOUR: 4,

    OTHER_SELECT: '',

    pathDefault: '',
    pathHome: '',

    hintMonth: '',
    hintDate: '',

    dataLanguage: [],
    langCodeCurrent: '',
    JAPANESE_TEXT_DISPLAY: '日本語/Eng',
    VIETNAMESE_TEXT_DISPLAY: 'Tiếng Việt',
    EVENT_BASIC_INFORMATION_FIELD,
    EVENT_ENTRY_INFORMATION_FIELD
  }),

  methods: {
    converTimestampToApplicantTimezone(time) {
      if (this.applicant) {
        const timezone = this.c_time_zone.filter((time) => {
          return time.id === this.applicant.time_zone;
        });
        if (timezone) {
          return moment_timezone.utc(time).tz(timezone[0].time_zone_code);
        }
      }
      return {};
    },
    isDisplayByApplicantTimeStamp(displayFrom, displayTo) {
      const displayFromByTS =
        this.converTimestampToApplicantTimezone(displayFrom);
      const displayToByTS = this.converTimestampToApplicantTimezone(displayTo);
      const now = this.converTimestampToApplicantTimezone(new Date());

      return (
        moment(displayFromByTS).isSameOrBefore(now) &&
        moment(now).isSameOrBefore(displayToByTS)
      );
    },
    isShowBasicInformationField(fieldName) {
      let field = [];
      if (this.m_template) {
        const basicInfo = this.m_template.participant_basic_info_type;
        const found = this.EVENT_BASIC_INFORMATION_FIELD.slice(0).find(
          (event) => {
            return event.eventType === basicInfo;
          }
        );

        if (found) {
          field = found.fields.find((name) => {
            return name === fieldName;
          });
        }
      }

      return field && true;
    },
    isShowEntryInformationField(fieldName) {
      let field = [];

      if (this.m_template) {
        const entryInfo = this.m_template.participant_entry_info_type;
        const found = this.EVENT_ENTRY_INFORMATION_FIELD.slice(0).find(
          (event) => {
            return event.eventType === entryInfo;
          }
        );

        if (found) {
          field = found.fields.find((name) => {
            return name === fieldName;
          });
        }
      }
      return field && true;
    },

    computedPerson(person) {
      const number = parseInt(person);
      if (number > 1) {
        return 'company-detail.title.company-information.persons';
      } else {
        return 'company-detail.title.company-information.person';
      }
    },

    getLocaleDatePicker() {
      // locale: vi or ja
      if (typeof this.$i18n.locale !== 'undefined') {
        const JAPANESE_LOCALE_CODE_VUETIFY = 'ja';
        if (this.$i18n.locale === LANG_CODE_JAPANESE)
          return JAPANESE_LOCALE_CODE_VUETIFY;
        else {
          return LANG_CODE_VIETNAMESE;
        }
      }
    },

    convertStr(str) {
      if (str !== null) {
        return str.replace(/  +/g, ' ');
      }

      return null;
    },

    industryTypeFormat: function (id) {
      const arr = this.m_industry_type.filter((ele) => ele.id === id);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    convertDateTime(datetime) {
      let dateString = '';
      if (datetime !== '' && datetime !== null) {
        const date = new Date(datetime.replace(/\s/, 'T'));
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          dateString =
            date.getFullYear() +
            '/' +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            '/' +
            ('0' + date.getDate()).slice(-2);
        } else {
          dateString =
            ('0' + date.getDate()).slice(-2) +
            '/' +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            '/' +
            date.getFullYear();
        }
      }
      return dateString;
    },

    checkDateFormate(date) {
      let result;
      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        result = date.match(REGEX_DATE_JAPANESE);
      } else {
        result = date.match(REGEX_DATE_VIETNAMESE);
      }
      return result && date;
    },

    checkMonthFormate(date) {
      let result;
      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        result = date.match(REGEX_MONTH_JAPANESE);
      } else {
        result = date.match(REGEX_MONTH_VIETNAMESE);
      }
      return result && date;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');

      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        return `${year}/${month}/${day}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    },

    formatMonth(date) {
      if (!date) return null;

      const [year, month] = date.split('-');
      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        return `${year}/${month}`;
      } else {
        return `${month}/${year}`;
      }
    },

    expectOccupationTypeFormat: function (occupation_type) {
      const arr = this.m_occupation_type_no_group.filter((ele) => {
        if (occupation_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    convertDateAndTime(datetime) {
      const date = new Date(datetime.replace(/\s/, 'T'));
      let dateString = '';
      let stringTime = '';

      let hours = null;
      let minutes = null;
      let seconds = null;

      hours =
        date.getHours().toString().length < 2
          ? '0' + date.getHours()
          : date.getHours();
      minutes =
        date.getMinutes().toString().length < 2
          ? '0' + date.getMinutes()
          : date.getMinutes();
      seconds =
        date.getSeconds().toString().length < 2
          ? '0' + date.getSeconds()
          : date.getSeconds();

      stringTime = `${hours}:${minutes}:${seconds}`;

      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        dateString =
          date.getFullYear() +
          '/' +
          ('0' + (date.getMonth() + 1)).slice(-2) +
          '/' +
          ('0' + date.getDate()).slice(-2) +
          ' ';
      } else {
        dateString =
          ('0' + date.getDate()).slice(-2) +
          '/' +
          ('0' + (date.getMonth() + 1)).slice(-2) +
          '/' +
          date.getFullYear() +
          ' ';
      }
      return dateString + stringTime;
    },

    getNowDateString() {
      const now = new Date();

      const dateString =
        now.getFullYear() +
        '-' +
        (parseFloat(now.getMonth()) + 1) +
        '-' +
        now.getDate();

      return dateString;
    },

    checkCurrentLanguage(langDefault) {
      const lang = localStorage.getItem('sekisho_lang')
        ? localStorage.getItem('sekisho_lang')
        : null;

      if (lang !== null) {
        return lang;
      } else {
        return this.getLangCodeFromEventDefault(langDefault);
      }
    },

    getLangCodeFromEventDefault(langDefault) {
      const langActive = this.dataLanguageFromServer.filter(
        (lang) => lang.id === langDefault
      );

      return langActive.length > 0 ? langActive[0].lang_code : 'jp_en';
    },

    setLang(langDefault) {
      const lang = this.checkCurrentLanguage(langDefault);
      Trans.changeLanguage(lang);
      this.$store.dispatch('changeLanguage', { lang });
    },

    changeLanguage(lang, title) {
      this.select = title;
      this.$store.dispatch('changeLanguage', { lang });
      Trans.changeLanguage(lang);
    },

    // HungPD Add 2023/10/09 Start
    convertDataUrlToBlob(dataUrl) {
      const arr = dataUrl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bStr = atob(arr[1]);
      let n = bStr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bStr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    generateString(length) {
      const characters =
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_';
      let result = ' ';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
    // HungPD Add 2023/10/10 End
  },

  watch: {
    pathDefault: function (val) {
      return val;
    },

    pathHome: function (val) {
      return val;
    },

    '$i18n.locale': function (val) {
      this.langCodeCurrent =
        val === LANG_CODE_JAPANESE ? LANG_CODE_JAPANESE : LANG_CODE_VIETNAMESE;
      this.hintMonth =
        val === LANG_CODE_JAPANESE
          ? HINT_TEXT_MONTH_JAPANESE
          : HINT_TEXT_MONTH_VIETNAMESE;
      this.hintDate =
        val === LANG_CODE_JAPANESE
          ? HINT_TEXT_DATE_JAPANESE
          : HINT_TEXT_DATE_VIETNAMESE;

      return val;
    }
  },

  mounted() {
    if (this.$store) {
      this.dataLanguage = Object.assign([], this.dataLanguageFromServer);

      const { state = '' } = this.$store;

      if (typeof state !== 'undefined' && state !== '') {
        const event = getEventFromLS(state);

        if (typeof event !== 'undefined' && event !== null) {
          const { event_code, contract_id } = event;

          const href = window.location.pathname;

          let pathDefault;
          if (href.includes('/entry')) {
            pathDefault = '/entry/' + contract_id + '/' + event_code;
          } else if (href.includes('/receptionist')) {
            pathDefault = '/receptionist/' + contract_id + '/' + event_code;
          }

          const pathHome = pathDefault + '/me';

          return (this.pathHome = pathHome), (this.pathDefault = pathDefault);
        }
      }

      if (typeof this.$i18n.locale !== 'undefined') {
        const lang = this.$i18n.locale;
        this.locale = this.$i18n.locale;
        this.hintMonth = lang === LANG_CODE_JAPANESE ? 'YYYY/MM' : 'MM/YYYY';
        this.hintDate =
          lang === LANG_CODE_JAPANESE ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
      }
    }
  },

  created() {
    this.OTHER_SELECT = OTHER_SELECT;
    this.LANG_CODE_JAPANESE = LANG_CODE_JAPANESE;
    this.LANG_CODE_VIETNAMESE = LANG_CODE_VIETNAMESE;
  },

  computed: {
    ...mapGetters({
      m_template: 'getMTemplate',
      applicant: 'getBasicInfomation',
      m_event: 'getEventData',
      registrationPeriodStatus: 'getRegistrationPeriodStatus',

      m_occupation_type_default: 'getMOccupationTypeDefault',

      c_time_zone: 'getCTimeZone',
      c_recruiting_target: 'getCRecruitingTarget',
      c_study_status: 'getCStudyStatus',
      c_work_status: 'getCWorkStatus',
      c_japanese_level: 'getCJapaneseLevel',
      c_english_level: 'getCEnglishLevel',
      c_work_contract_type: 'getCWorkContractType',
      m_skill_type: 'getMSkillType',
      m_skill: 'getMSkill',
      m_work_location_applicant: 'getMWorkLocationApplicant',
      m_work_location_company: 'getMWorkLocationCompany',
      m_occupation_type: 'getMOccupationType',
      m_occupation_type_no_group: 'getMOccupationTypeNoGroup',
      m_industry_type: 'getMIndustryType',
      registerStatus: 'getRegisterStatus',
      registerResult: 'getRegisterResult',
      m_occupation_type_company: 'getMOccupationTypeCompany',
      m_area: 'getArea',
      m_input_example: 'getInputExample',
      c_language: 'getCLanguage',
      c_system: 'getCSystem',
      m_hometown: 'getHometown',

      checkEvent: 'getStatusCheckEvent',
      checkAuth: 'getStatusCheckAuth',
      checkAuthReceptionist: 'getStatusCheckAuthReceptionist',
      arrayFavoriteId: 'getArrayCompanyFavoriteId',
      m_privacy_policy: 'getMPrivacyPolicy',
      m_university: 'getMUniversity',
      m_faculty: 'getMFaculty',
      fullPath: 'getFullPath',
      surveyTemplate: 'getMSurveyTemplate',
      dataLanguageFromServer: 'getDataLanguage',
      langTitle: 'getLangDefaultTitle'
    }),

    getHint() {
      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        return HINT_TEXT_DATE_JAPANESE;
      } else {
        return HINT_TEXT_DATE_VIETNAMESE;
      }
    },
    getApplicantEntry() {
      if (this.applicant) {
        return this.applicant.entry_no;
      }
      return '';
    },
    isDisplayEventSchedulePage() {
      if (this.m_event) {
        return this.m_event.event_schedule_use_flag === PUBLIC_FLAG;
      }
      return false;
    },
    isDisplayScoutMailPage() {
      if (this.m_event) {
        return this.m_event.scout_mail_use_flag === PUBLIC_FLAG;
      }
      return false;
    },
    isDisplayInterviewlPage() {
      if (this.m_event) {
        return this.m_event.interview_function === PUBLIC_FLAG;
      }
      return false;
    }
  }
};
